// extracted by mini-css-extract-plugin
export default {"CustomModal":"CustomModal_CustomModal__D94V0","CloseAction":"CustomModal_CloseAction__pp+pT"};